import { Base64 } from 'js-base64';

import { CheckoutThemeFormValues } from './types';
import { extractColorValue } from 'utils/colorUtils';

export const defaultCheckoutThemeV2: CheckoutThemeFormValues = {
  publisherId: '',
  _id: '',
  logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  primaryColor: '#7122ff',
  textColor: '#ffffff',
  backgroundImage: 'https://media.appcharge.com/defaults/background.png',
  mobileBgImage: '',
  buttonColor: '#7122ff',
  buttonTextColor: '#ffffff',
  footerConfiguration: {
    DEFAULT: {
      richText: Base64.encode('')
    }
  }
};

export const defaultCheckoutThemeV3: CheckoutThemeFormValues = {
  publisherId: '',
  _id: '',
  logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  textColor: '#000000',
  backgroundImage: '',
  mobileBgImage: '',
  footerConfiguration: {
    DEFAULT: {
      richText: Base64.encode('')
    }
  }
};

export const checkoutTextColorOptions = [
  {
    content: 'White',
    key: 'white',
    value: '#ffffff'
  },
  {
    content: 'Black',
    key: 'black',
    value: '#000000'
  }
];

export const getDefaultFontColorByVersion = (
  isCheckoutV3Enabled: boolean,
  textColor?: string
) => {
  if (!textColor) {
    return isCheckoutV3Enabled
      ? defaultCheckoutThemeV3.textColor
      : defaultCheckoutThemeV2.textColor;
  }
  if (isCheckoutV3Enabled) {
    if (textColor === '#ffffff' || textColor === '#000000') {
      return textColor;
    }
    return '#000000';
  }
  return extractColorValue(textColor);
};

export const getDefaultBackgroundImageByVersion = (
  isCheckoutV3Enabled: boolean,
  backgroundImage: string
) => {
  if (isCheckoutV3Enabled) {
    if (backgroundImage === defaultCheckoutThemeV2.backgroundImage) {
      return '';
    }
    return backgroundImage;
  }
  return backgroundImage || defaultCheckoutThemeV2.backgroundImage;
};
